import React from 'react';
import { MessageCircle, Mail, Linkedin } from 'lucide-react';
import { contactInfo, socialLinks } from '../data/mock';
import { trackCtaClick } from '../utils/analytics';

const Contact = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(contactInfo.whatsappMessage);
    const whatsappUrl = `https://wa.me/${contactInfo.whatsapp.replace(/[^0-9]/g, '')}?text=${message}`;
    trackCtaClick({ cta: 'whatsapp', location: 'contact', url: whatsappUrl });
    window.open(whatsappUrl, '_blank');
  };

  const handleEmailClick = () => {
    const emailUrl = `mailto:${contactInfo.email}`;
    trackCtaClick({ cta: 'email', location: 'contact', url: emailUrl });
    window.location.href = emailUrl;
  };

  const handleLinkedInClick = () => {
    trackCtaClick({ cta: 'linkedin', location: 'contact', url: socialLinks.linkedin });
    window.open(socialLinks.linkedin, '_blank');
  };

  return (
    <section id="contato" className="section-padding section-bg">
      <div className="container-custom">
        <div className="contact-content">
          <h2 className="section-title">Vamos conversar?</h2>
          <p className="contact-description">
            Quer melhorar conectividade, automação ou arquitetura digital? 
            Conte comigo para transformar sua ideia em solução real.
          </p>
          
          <div className="contact-buttons">
            <button onClick={handleWhatsAppClick} className="btn-primary btn-large">
              <MessageCircle size={24} />
              WhatsApp
            </button>
            <button onClick={handleEmailClick} className="btn-secondary btn-large">
              <Mail size={24} />
              Email
            </button>
            <button onClick={handleLinkedInClick} className="btn-secondary btn-large">
              <Linkedin size={24} />
              LinkedIn
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
